const ONE_HOUR_IN_SECONDS = 60 * 60;

export default function prepareTimestampStr(
	videoDuration: number,
	timestampStr: string,
) {
	if (timestampStr?.length === 4 || timestampStr?.length === 5) {
		// MM:SS format
		return timestampStr;
	}

	if (videoDuration < ONE_HOUR_IN_SECONDS && timestampStr) {
		return timestampStr?.slice(3);
	}

	return timestampStr;
}
